const compatModules = {};import * as Mod1 from "./discourse/components/code-view";
compatModules["discourse/components/code-view"] = Mod1;

export * as discourse$components$code__view$$__module from "./discourse/components/code-view";
export {
default as discourse$components$code__view$$default
} from "./discourse/components/code-view";
import * as Mod2 from "./discourse/components/data-explorer-bar-chart";
compatModules["discourse/components/data-explorer-bar-chart"] = Mod2;

export * as discourse$components$data__explorer__bar__chart$$__module from "./discourse/components/data-explorer-bar-chart";
export {
default as discourse$components$data__explorer__bar__chart$$default
} from "./discourse/components/data-explorer-bar-chart";
import * as Mod3 from "./discourse/components/explorer-schema";
compatModules["discourse/components/explorer-schema"] = Mod3;

export * as discourse$components$explorer__schema$$__module from "./discourse/components/explorer-schema";
export {
default as discourse$components$explorer__schema$$default
} from "./discourse/components/explorer-schema";
import * as Mod4 from "./discourse/components/explorer-schema/enum-info";
compatModules["discourse/components/explorer-schema/enum-info"] = Mod4;

export * as discourse$components$explorer__schema$enum__info$$__module from "./discourse/components/explorer-schema/enum-info";
export {
default as discourse$components$explorer__schema$enum__info$$default
} from "./discourse/components/explorer-schema/enum-info";
import * as Mod5 from "./discourse/components/explorer-schema/one-table";
compatModules["discourse/components/explorer-schema/one-table"] = Mod5;

export * as discourse$components$explorer__schema$one__table$$__module from "./discourse/components/explorer-schema/one-table";
export {
default as discourse$components$explorer__schema$one__table$$default
} from "./discourse/components/explorer-schema/one-table";
import * as Mod6 from "./discourse/components/modal/query-help";
compatModules["discourse/components/modal/query-help"] = Mod6;

export * as discourse$components$modal$query__help$$__module from "./discourse/components/modal/query-help";
export {
default as discourse$components$modal$query__help$$default
} from "./discourse/components/modal/query-help";
import * as Mod7 from "./discourse/components/param-input-form";
compatModules["discourse/components/param-input-form"] = Mod7;

export * as discourse$components$param__input__form$$__module from "./discourse/components/param-input-form";
export {
ParamValidationError as discourse$components$param__input__form$$ParamValidationError,
ERRORS as discourse$components$param__input__form$$ERRORS,
default as discourse$components$param__input__form$$default
} from "./discourse/components/param-input-form";
import * as Mod8 from "./discourse/components/param-input/boolean-three";
compatModules["discourse/components/param-input/boolean-three"] = Mod8;

export * as discourse$components$param__input$boolean__three$$__module from "./discourse/components/param-input/boolean-three";
export {
default as discourse$components$param__input$boolean__three$$default
} from "./discourse/components/param-input/boolean-three";
import * as Mod9 from "./discourse/components/param-input/category-id-input";
compatModules["discourse/components/param-input/category-id-input"] = Mod9;

export * as discourse$components$param__input$category__id__input$$__module from "./discourse/components/param-input/category-id-input";
export {
default as discourse$components$param__input$category__id__input$$default
} from "./discourse/components/param-input/category-id-input";
import * as Mod10 from "./discourse/components/param-input/group-input";
compatModules["discourse/components/param-input/group-input"] = Mod10;

export * as discourse$components$param__input$group__input$$__module from "./discourse/components/param-input/group-input";
export {
default as discourse$components$param__input$group__input$$default
} from "./discourse/components/param-input/group-input";
import * as Mod11 from "./discourse/components/param-input/user-id-input";
compatModules["discourse/components/param-input/user-id-input"] = Mod11;

export * as discourse$components$param__input$user__id__input$$__module from "./discourse/components/param-input/user-id-input";
export {
default as discourse$components$param__input$user__id__input$$default
} from "./discourse/components/param-input/user-id-input";
import * as Mod12 from "./discourse/components/param-input/user-list-input";
compatModules["discourse/components/param-input/user-list-input"] = Mod12;

export * as discourse$components$param__input$user__list__input$$__module from "./discourse/components/param-input/user-list-input";
export {
default as discourse$components$param__input$user__list__input$$default
} from "./discourse/components/param-input/user-list-input";
import * as Mod13 from "./discourse/components/query-result";
compatModules["discourse/components/query-result"] = Mod13;

export * as discourse$components$query__result$$__module from "./discourse/components/query-result";
export {
default as discourse$components$query__result$$default
} from "./discourse/components/query-result";
import * as Mod14 from "./discourse/components/query-results-wrapper";
compatModules["discourse/components/query-results-wrapper"] = Mod14;

export * as discourse$components$query__results__wrapper$$__module from "./discourse/components/query-results-wrapper";
export {
default as discourse$components$query__results__wrapper$$default
} from "./discourse/components/query-results-wrapper";
import * as Mod15 from "./discourse/components/query-row-content";
compatModules["discourse/components/query-row-content"] = Mod15;

export * as discourse$components$query__row__content$$__module from "./discourse/components/query-row-content";
export {
default as discourse$components$query__row__content$$default
} from "./discourse/components/query-row-content";
import * as Mod16 from "./discourse/components/result-types/badge";
compatModules["discourse/components/result-types/badge"] = Mod16;

export * as discourse$components$result__types$badge$$__module from "./discourse/components/result-types/badge";
export {
default as discourse$components$result__types$badge$$default
} from "./discourse/components/result-types/badge";
import * as Mod17 from "./discourse/components/result-types/category";
compatModules["discourse/components/result-types/category"] = Mod17;

export * as discourse$components$result__types$category$$__module from "./discourse/components/result-types/category";
export {
default as discourse$components$result__types$category$$default
} from "./discourse/components/result-types/category";
import * as Mod18 from "./discourse/components/result-types/group";
compatModules["discourse/components/result-types/group"] = Mod18;

export * as discourse$components$result__types$group$$__module from "./discourse/components/result-types/group";
export {
default as discourse$components$result__types$group$$default
} from "./discourse/components/result-types/group";
import * as Mod19 from "./discourse/components/result-types/html";
compatModules["discourse/components/result-types/html"] = Mod19;

export * as discourse$components$result__types$html$$__module from "./discourse/components/result-types/html";
export {
default as discourse$components$result__types$html$$default
} from "./discourse/components/result-types/html";
import * as Mod20 from "./discourse/components/result-types/json";
compatModules["discourse/components/result-types/json"] = Mod20;

export * as discourse$components$result__types$json$$__module from "./discourse/components/result-types/json";
export {
default as discourse$components$result__types$json$$default
} from "./discourse/components/result-types/json";
import * as Mod21 from "./discourse/components/result-types/post";
compatModules["discourse/components/result-types/post"] = Mod21;

export * as discourse$components$result__types$post$$__module from "./discourse/components/result-types/post";
export {
default as discourse$components$result__types$post$$default
} from "./discourse/components/result-types/post";
import * as Mod22 from "./discourse/components/result-types/reltime";
compatModules["discourse/components/result-types/reltime"] = Mod22;

export * as discourse$components$result__types$reltime$$__module from "./discourse/components/result-types/reltime";
export {
default as discourse$components$result__types$reltime$$default
} from "./discourse/components/result-types/reltime";
import * as Mod23 from "./discourse/components/result-types/tag-group";
compatModules["discourse/components/result-types/tag-group"] = Mod23;

export * as discourse$components$result__types$tag__group$$__module from "./discourse/components/result-types/tag-group";
export {
default as discourse$components$result__types$tag__group$$default
} from "./discourse/components/result-types/tag-group";
import * as Mod24 from "./discourse/components/result-types/text";
compatModules["discourse/components/result-types/text"] = Mod24;

export * as discourse$components$result__types$text$$__module from "./discourse/components/result-types/text";
export {
default as discourse$components$result__types$text$$default
} from "./discourse/components/result-types/text";
import * as Mod25 from "./discourse/components/result-types/topic";
compatModules["discourse/components/result-types/topic"] = Mod25;

export * as discourse$components$result__types$topic$$__module from "./discourse/components/result-types/topic";
export {
default as discourse$components$result__types$topic$$default
} from "./discourse/components/result-types/topic";
import * as Mod26 from "./discourse/components/result-types/url";
compatModules["discourse/components/result-types/url"] = Mod26;

export * as discourse$components$result__types$url$$__module from "./discourse/components/result-types/url";
export {
default as discourse$components$result__types$url$$default
} from "./discourse/components/result-types/url";
import * as Mod27 from "./discourse/components/result-types/user";
compatModules["discourse/components/result-types/user"] = Mod27;

export * as discourse$components$result__types$user$$__module from "./discourse/components/result-types/user";
export {
default as discourse$components$result__types$user$$default
} from "./discourse/components/result-types/user";
import * as Mod28 from "./discourse/components/share-report";
compatModules["discourse/components/share-report"] = Mod28;

export * as discourse$components$share__report$$__module from "./discourse/components/share-report";
export {
default as discourse$components$share__report$$default
} from "./discourse/components/share-report";
import * as Mod29 from "./discourse/connectors/group-reports-nav-item/nav-item.gjs";
compatModules["discourse/connectors/group-reports-nav-item/nav-item"] = Mod29;

export * as discourse$connectors$group__reports__nav__item$nav__item$$__module from "./discourse/connectors/group-reports-nav-item/nav-item.gjs";
export {
default as discourse$connectors$group__reports__nav__item$nav__item$$default
} from "./discourse/connectors/group-reports-nav-item/nav-item.gjs";
import * as Mod30 from "./discourse/controllers/admin-plugins/show/explorer";
compatModules["discourse/controllers/admin-plugins/show/explorer"] = Mod30;

export * as discourse$controllers$admin__plugins$show$explorer$$__module from "./discourse/controllers/admin-plugins/show/explorer";
export {
default as discourse$controllers$admin__plugins$show$explorer$$default
} from "./discourse/controllers/admin-plugins/show/explorer";
import * as Mod31 from "./discourse/controllers/admin-plugins/show/explorer/details";
compatModules["discourse/controllers/admin-plugins/show/explorer/details"] = Mod31;

export * as discourse$controllers$admin__plugins$show$explorer$details$$__module from "./discourse/controllers/admin-plugins/show/explorer/details";
export {
default as discourse$controllers$admin__plugins$show$explorer$details$$default
} from "./discourse/controllers/admin-plugins/show/explorer/details";
import * as Mod32 from "./discourse/controllers/admin-plugins/show/explorer/index";
compatModules["discourse/controllers/admin-plugins/show/explorer/index"] = Mod32;

export * as discourse$controllers$admin__plugins$show$explorer$index$$__module from "./discourse/controllers/admin-plugins/show/explorer/index";
export {
default as discourse$controllers$admin__plugins$show$explorer$index$$default
} from "./discourse/controllers/admin-plugins/show/explorer/index";
import * as Mod33 from "./discourse/controllers/group/reports";
compatModules["discourse/controllers/group/reports"] = Mod33;

export * as discourse$controllers$group$reports$$__module from "./discourse/controllers/group/reports";
export {
default as discourse$controllers$group$reports$$default
} from "./discourse/controllers/group/reports";
import * as Mod34 from "./discourse/controllers/group/reports/index";
compatModules["discourse/controllers/group/reports/index"] = Mod34;

export * as discourse$controllers$group$reports$index$$__module from "./discourse/controllers/group/reports/index";
export {
default as discourse$controllers$group$reports$index$$default
} from "./discourse/controllers/group/reports/index";
import * as Mod35 from "./discourse/controllers/group/reports/show";
compatModules["discourse/controllers/group/reports/show"] = Mod35;

export * as discourse$controllers$group$reports$show$$__module from "./discourse/controllers/group/reports/show";
export {
default as discourse$controllers$group$reports$show$$default
} from "./discourse/controllers/group/reports/show";
import * as Mod36 from "./discourse/explorer-legacy-route-map";
compatModules["discourse/explorer-legacy-route-map"] = Mod36;

export * as discourse$explorer__legacy__route__map$$__module from "./discourse/explorer-legacy-route-map";
export {
default as discourse$explorer__legacy__route__map$$default
} from "./discourse/explorer-legacy-route-map";
import * as Mod37 from "./discourse/explorer-route-map";
compatModules["discourse/explorer-route-map"] = Mod37;

export * as discourse$explorer__route__map$$__module from "./discourse/explorer-route-map";
export {
default as discourse$explorer__route__map$$default
} from "./discourse/explorer-route-map";
import * as Mod38 from "./discourse/group-reports-route-map";
compatModules["discourse/group-reports-route-map"] = Mod38;

export * as discourse$group__reports__route__map$$__module from "./discourse/group-reports-route-map";
export {
default as discourse$group__reports__route__map$$default
} from "./discourse/group-reports-route-map";
import * as Mod39 from "./discourse/initializers/data-explorer-admin-plugin-configuration-nav";
compatModules["discourse/initializers/data-explorer-admin-plugin-configuration-nav"] = Mod39;

export * as discourse$initializers$data__explorer__admin__plugin__configuration__nav$$__module from "./discourse/initializers/data-explorer-admin-plugin-configuration-nav";
export {
default as discourse$initializers$data__explorer__admin__plugin__configuration__nav$$default
} from "./discourse/initializers/data-explorer-admin-plugin-configuration-nav";
import * as Mod40 from "./discourse/initializers/initialize-data-explorer";
compatModules["discourse/initializers/initialize-data-explorer"] = Mod40;

export * as discourse$initializers$initialize__data__explorer$$__module from "./discourse/initializers/initialize-data-explorer";
export {
default as discourse$initializers$initialize__data__explorer$$default
} from "./discourse/initializers/initialize-data-explorer";
import * as Mod41 from "./discourse/lib/constants";
compatModules["discourse/lib/constants"] = Mod41;

export * as discourse$lib$constants$$__module from "./discourse/lib/constants";
export {
QUERY_RESULT_MAX_LIMIT as discourse$lib$constants$$QUERY_RESULT_MAX_LIMIT
} from "./discourse/lib/constants";
import * as Mod42 from "./discourse/lib/themeColor";
compatModules["discourse/lib/themeColor"] = Mod42;

export * as discourse$lib$themeColor$$__module from "./discourse/lib/themeColor";
export {
default as discourse$lib$themeColor$$default
} from "./discourse/lib/themeColor";
import * as Mod43 from "./discourse/models/query";
compatModules["discourse/models/query"] = Mod43;

export * as discourse$models$query$$__module from "./discourse/models/query";
export {
default as discourse$models$query$$default
} from "./discourse/models/query";
import * as Mod44 from "./discourse/routes/admin-plugins/explorer";
compatModules["discourse/routes/admin-plugins/explorer"] = Mod44;

export * as discourse$routes$admin__plugins$explorer$$__module from "./discourse/routes/admin-plugins/explorer";
export {
default as discourse$routes$admin__plugins$explorer$$default
} from "./discourse/routes/admin-plugins/explorer";
import * as Mod45 from "./discourse/routes/admin-plugins/explorer/index";
compatModules["discourse/routes/admin-plugins/explorer/index"] = Mod45;

export * as discourse$routes$admin__plugins$explorer$index$$__module from "./discourse/routes/admin-plugins/explorer/index";
export {
default as discourse$routes$admin__plugins$explorer$index$$default
} from "./discourse/routes/admin-plugins/explorer/index";
import * as Mod46 from "./discourse/routes/admin-plugins/explorer/queries";
compatModules["discourse/routes/admin-plugins/explorer/queries"] = Mod46;

export * as discourse$routes$admin__plugins$explorer$queries$$__module from "./discourse/routes/admin-plugins/explorer/queries";
export {
default as discourse$routes$admin__plugins$explorer$queries$$default
} from "./discourse/routes/admin-plugins/explorer/queries";
import * as Mod47 from "./discourse/routes/admin-plugins/explorer/queries/details";
compatModules["discourse/routes/admin-plugins/explorer/queries/details"] = Mod47;

export * as discourse$routes$admin__plugins$explorer$queries$details$$__module from "./discourse/routes/admin-plugins/explorer/queries/details";
export {
default as discourse$routes$admin__plugins$explorer$queries$details$$default
} from "./discourse/routes/admin-plugins/explorer/queries/details";
import * as Mod48 from "./discourse/routes/admin-plugins/explorer/queries/index";
compatModules["discourse/routes/admin-plugins/explorer/queries/index"] = Mod48;

export * as discourse$routes$admin__plugins$explorer$queries$index$$__module from "./discourse/routes/admin-plugins/explorer/queries/index";
export {
default as discourse$routes$admin__plugins$explorer$queries$index$$default
} from "./discourse/routes/admin-plugins/explorer/queries/index";
import * as Mod49 from "./discourse/routes/admin-plugins/show/explorer";
compatModules["discourse/routes/admin-plugins/show/explorer"] = Mod49;

export * as discourse$routes$admin__plugins$show$explorer$$__module from "./discourse/routes/admin-plugins/show/explorer";
export {
default as discourse$routes$admin__plugins$show$explorer$$default
} from "./discourse/routes/admin-plugins/show/explorer";
import * as Mod50 from "./discourse/routes/admin-plugins/show/explorer/details";
compatModules["discourse/routes/admin-plugins/show/explorer/details"] = Mod50;

export * as discourse$routes$admin__plugins$show$explorer$details$$__module from "./discourse/routes/admin-plugins/show/explorer/details";
export {
default as discourse$routes$admin__plugins$show$explorer$details$$default
} from "./discourse/routes/admin-plugins/show/explorer/details";
import * as Mod51 from "./discourse/routes/admin-plugins/show/explorer/index";
compatModules["discourse/routes/admin-plugins/show/explorer/index"] = Mod51;

export * as discourse$routes$admin__plugins$show$explorer$index$$__module from "./discourse/routes/admin-plugins/show/explorer/index";
export {
default as discourse$routes$admin__plugins$show$explorer$index$$default
} from "./discourse/routes/admin-plugins/show/explorer/index";
import * as Mod52 from "./discourse/routes/group/reports";
compatModules["discourse/routes/group/reports"] = Mod52;

export * as discourse$routes$group$reports$$__module from "./discourse/routes/group/reports";
export {
default as discourse$routes$group$reports$$default
} from "./discourse/routes/group/reports";
import * as Mod53 from "./discourse/routes/group/reports/index";
compatModules["discourse/routes/group/reports/index"] = Mod53;

export * as discourse$routes$group$reports$index$$__module from "./discourse/routes/group/reports/index";
export {
default as discourse$routes$group$reports$index$$default
} from "./discourse/routes/group/reports/index";
import * as Mod54 from "./discourse/routes/group/reports/show";
compatModules["discourse/routes/group/reports/show"] = Mod54;

export * as discourse$routes$group$reports$show$$__module from "./discourse/routes/group/reports/show";
export {
default as discourse$routes$group$reports$show$$default
} from "./discourse/routes/group/reports/show";
import * as Mod55 from "./discourse/templates/group/reports";
compatModules["discourse/templates/group/reports"] = Mod55;

export * as discourse$templates$group$reports$$__module from "./discourse/templates/group/reports";
export {
default as discourse$templates$group$reports$$default
} from "./discourse/templates/group/reports";
import * as Mod56 from "./discourse/templates/group/reports/index";
compatModules["discourse/templates/group/reports/index"] = Mod56;

export * as discourse$templates$group$reports$index$$__module from "./discourse/templates/group/reports/index";
export {
default as discourse$templates$group$reports$index$$default
} from "./discourse/templates/group/reports/index";
import * as Mod57 from "./discourse/templates/group/reports/show";
compatModules["discourse/templates/group/reports/show"] = Mod57;

export * as discourse$templates$group$reports$show$$__module from "./discourse/templates/group/reports/show";
export {
default as discourse$templates$group$reports$show$$default
} from "./discourse/templates/group/reports/show";
export default compatModules;
